import type { ReactNode } from "react";

interface CRTScreenProps {
  children: ReactNode;
  className?: string;
}

export function CRTScreen({ children, className = "" }: CRTScreenProps) {
  return (
    <div className={`crt-screen ${className}`} style={{ height: "100%" }}>
      {children}
    </div>
  );
}
